export default __webpack_public_path__ + "static/media/2502111.758fbd51.jpg";